// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const SocialInstagram: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path d="M25.5 19.8c-2.9 0-5.2 2.3-5.2 5.2 0 2.9 2.3 5.2 5.2 5.2 2.9 0 5.2-2.3 5.2-5.2 0-2.9-2.3-5.2-5.2-5.2z"/><path d="M31.6 13.4H19.4c-3 0-5.5 2.5-5.5 5.5v12.2c0 3 2.5 5.5 5.5 5.5h12.2c3 0 5.5-2.5 5.5-5.5V18.9c0-3-2.5-5.5-5.5-5.5zm-6.1 18.3a6.7 6.7 0 110-13.4 6.7 6.7 0 010 13.4zm7.6-12.3c-.8 0-1.5-.6-1.5-1.5 0-.8.6-1.5 1.5-1.5.8 0 1.5.7 1.5 1.5-.1.9-.7 1.5-1.5 1.5z"/></svg>;
};

export default React.memo(SocialInstagram);
